import React from "react";
import Link from "gatsby-link";
import ClassNames from "classnames";
import RenderHtml from "../utils/render-html";

import IngredientsModal from "../components/ingredients/modal"
import Bus from "../utils/bus";
let BUS = new Bus();

class Intro extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let ingredients = this.props.ingredients;
    return (
      <div className="BuyIngredients2-outer">
        <div className="BuyIngredients2">
          <h2 id="Ingredients">Ingredients that Make the Difference in Your Yoga Session</h2>
          <div className="items">
              {ingredients.map(({ node }, i) => {
                return (
                  <div id={node.name.replace(/\W+/g, '-').toLowerCase()} className="item" key={i}>
                    <div className="info">
                      <img src={node.image.fluid.src} />
                      <h3>{node.name}</h3>
                      <h4>{node.subName}</h4>
                      <div
                        className="description"
                        dangerouslySetInnerHTML={RenderHtml.go(
                          node.shortDescription
                        )}
                      />
                      <span onClick={() => {
                        BUS.trigger("OPEN_INGREDIENTMODAL", {
                          content: node.descriptionExtended
                        })
                      }}>LEARN MORE</span>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
        <IngredientsModal />
      </div>
    );
  }
}

export default Intro;



// WEBPACK FOOTER //
// ./src/buy/ingredients.js